import * as React from 'react'
import { tv, VariantProps } from 'tailwind-variants'

const headingWithIconVariants = tv({
  base: 'flex items-center gap-3',
  variants: {
    size: {
      sm: 'gap-2',
      default: 'gap-3',
      lg: 'gap-4'
    }
  },
  defaultVariants: {
    size: 'default'
  }
})

const iconVariants = tv({
  base: 'text-gray-600',
  variants: {
    size: {
      sm: 'h-5 w-5',
      default: 'h-6 w-6',
      lg: 'h-8 w-8'
    }
  },
  defaultVariants: {
    size: 'default'
  }
})

const titleVariants = tv({
  base: 'font-semibold text-gray-900',
  variants: {
    size: {
      sm: 'text-lg',
      default: 'text-xl',
      lg: 'text-2xl'
    }
  },
  defaultVariants: {
    size: 'default'
  }
})

export interface HeadingWithIconProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof headingWithIconVariants> {
  icon?: React.ReactNode
  children: React.ReactNode
}

const HeadingWithIcon = React.forwardRef<HTMLDivElement, HeadingWithIconProps>(
  ({ className, size = 'default', icon, children, ...props }, ref) => {
    const defaultIcon = (
      <svg
        className={iconVariants({ size })}
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V9ZM19 9H14V4H5V21H19V9Z" />
      </svg>
    )

    return (
      <div ref={ref} className={headingWithIconVariants({ size, className })} {...props}>
        <div className={iconVariants({ size })}>{icon || defaultIcon}</div>
        <h2 className={titleVariants({ size })}>{children}</h2>
      </div>
    )
  }
)

HeadingWithIcon.displayName = 'HeadingWithIcon'

export { HeadingWithIcon, headingWithIconVariants }
